export default "__VITE_ASSET__DbxY3lhs__"